export default {
  install(Vue) {
    Vue.prototype.$apiLink = link => process.env.VUE_APP_API + link;
  },
};
